import store from '../index.js'
import { globalFetch } from "foundation/js/api"

export default {
    namespaced: true,
    state: {
        isSubmitting: false,
        errorMessage: '',
        personalDonationInput: null,
        stafetId: '',
        donationFor: 'none',
        donationTeam: '',
        donationParticipant: '',
        donationFlowId: '',
        userInputs: [],
        steps: [],
        currentStep: 1,
        basket: [],
        basketTotalPrice: 0,
        teams: [],
        participants: []
    },
    mutations: {
        store_personal_donation_input(state, input) {
            state.personalDonationInput = input
        },
        set_stafet_id(state, stafetId) {
            state.stafetId = stafetId
        },
        set_donation_for(state, donationFor) {
            state.donationFor = donationFor
        },
        set_donation_team(state, team) {
            state.donationTeam = team
        },
        set_donation_participant(state, participant) {
            state.donationParticipant = participant
        },
        set_teams(state, teams) {
            state.teams = teams
        },
        set_participants(state, participants) {
            state.participants = participants
        },
        set_donation_flow_id(state, id) {
            state.donationFlowId = id
        },
        set_user_inputs(state, inputs) {
            state.userInputs = inputs
        },
        set_steps(state, steps) {
            state.steps = steps
        },
        set_current_step(state, step) {
            state.currentStep = step
        },
        set_basket(state, basket) {
            state.basket = basket
        },
        set_basket_total_price(state, price) {
            state.basketTotalPrice = price
        },
        set_error_message(state, message) {
            state.errorMessage = message
        },
        set_is_submitting(state, isSubmitting) {
            state.isSubmitting = isSubmitting
        }
    },
    actions: {
        stafetId(context, config) {
            context.commit('set_stafet_id', config.stafetId)
        },
        donationFor(context, config) {
            context.commit('set_donation_for', config.donationFor)
        },
        donationTeam(context, config) {
            context.commit('set_donation_team', config.team)
        },
        donationParticipant(context, config) {
            context.commit('set_donation_participant', config.participant)
        },
        teams(context, config) {
            const url = `${document.location.origin}/${process.env.GET_STAFET_TEAM_LIST
                .replace('[stafetId]', config.stafetId)
                .replace('[pageId]', store.state.main.page_id)}`
            globalFetch(url)
                .then((response) => response.json())
                .then((data) => {
                    context.commit('set_teams', data.hits)
                })
                .catch((err) => {
                    console.error(err)
                })
        },
        participants(context, config) {
            if (config?.teamId === undefined) {
                context.commit('set_participants', [])
            } else {
                const url = `${document.location.origin}/${process.env.GET_STAFET_PARTICIPANTS.replace('[teamId]', config.teamId)}`
                globalFetch(url)
                    .then((response) => response.json())
                    .then((data) => {
                        context.commit('set_participants', data.hits)
                    })
                    .catch((err) => {
                        console.error(err)
                    })
            }
        },
        userInputs(context, config) {
            const userInputs = context.state.userInputs
            if (userInputs.length === 0) {
                context.commit('set_user_inputs', config.inputs)
            } else {
                const nonMatchingValuesList = []

                userInputs.map((item) => {
                    const match = config.inputs.find(
                        (newItem) => newItem.name === item.name
                    )
                    if (!match) {
                        nonMatchingValuesList.push(item)
                    }
                })

                context.commit('set_user_inputs', [
                    ...nonMatchingValuesList,
                    ...config.inputs
                ])
            }
        },
        steps(context, config) {
            context.commit('set_steps', config.steps)
        },
        currentStep(context, config) {
            context.commit('set_current_step', config.step)
        },
        basket(context, config) {
            const basket = context.state.basket
            let updatedBasket = []
            if (basket.length === 0) {
                updatedBasket = config.basket
            } else {
                const nonMatchingValuesList = []

                basket.map((item) => {
                    const match = config.basket.find(
                        (newItem) => newItem.name === item.name
                    )
                    if (!match) {
                        nonMatchingValuesList.push(item)
                    }
                })

                updatedBasket = [...nonMatchingValuesList, ...config.basket]
            }

            context.commit('set_basket', updatedBasket)
            let totalPrice = 0
            updatedBasket.map((item) => {
                totalPrice += item.intPrice
            })
            context.commit('set_basket_total_price', totalPrice)
        },
        basketTotalPrice(context, config) {
            context.commit('set_basket_total_price', config.price)
        },
        donationSubmit(context) {
            const url =
                `${document.location.origin}/${process.env.SUBMIT_STAFET_DONATION}`.replace(
                    '[pageId]',
                    store.state.main.page_id
                )
            const method = process.env.POSTMETHOD
            const fields = context.state.userInputs

            const data = getUserInputsBody(fields, [
                'type',
                'amount',
                'holdKode',
                'deltagerId',
                'comment',
                'isAnonymous',
                'taxDeduction',
                'cpr',
                'cvr',
                'companyName',
                'companyWebsite',
                'companyLogo'
            ])

            const formdata = new FormData()
            formdata.append('stafetKode', context.state.stafetId)
            formdata.append('deltagerId', data.deltagerId ||= '')
            formdata.append('sponsorId', data.sponsorId ||= '')
            formdata.append('paymentMethod', 'PaymentCard')
            formdata.append('type', data.type)
            formdata.append('amount', data.amount)
            formdata.append('holdKode', data.holdKode)
            formdata.append('comment', data.comment)
            formdata.append('isAnonymous', data.isAnonymous ||= false)
            formdata.append('taxDeduction', data.taxDeduction)
            formdata.append('cpr', data.cpr ||= '')
            formdata.append('cvr', data.cvr ||= '')
            formdata.append('supportStafet', context.state.donationFor === 'stafet')
            formdata.append('supportHold', context.state.donationFor === 'team')
            formdata.append('supportDeltager', context.state.donationFor === 'participant')

            if (data.companyLogo) {
                formdata.append('image', data.companyLogo[0])
            }

            formdata.append('invoiceAddress.firstName', fields.find((item) => item.name === 'firstName').value)
            formdata.append('invoiceAddress.lastName', fields.find((item) => item.name === 'lastName').value)
            formdata.append('invoiceAddress.email', fields.find((item) => item.name === 'email').value)

            if (fields.find((item) => item.name === 'phone')) {
                formdata.append('invoiceAddress.phone', fields.find((item) => item.name === 'phone').value)
            }
            if (fields.find((item) => item.name === 'companyName')) {
                formdata.append('invoiceAddress.companyName', fields.find((item) => item.name === 'companyName').value)
            }
            if (fields.find((item) => item.name === 'companyWebsite')) {
                formdata.append('invoiceAddress.companyWebsite', fields.find((item) => item.name === 'companyWebsite').value)
            }
            if (fields.find((item) => item.name === 'companyAddress')) {
                formdata.append('invoiceAddress.companyAddress', fields.find((item) => item.name === 'companyAddress').value)
            }
            if (fields.find((item) => item.name === 'companyPostalCode')) {
                formdata.append('invoiceAddress.zipCode', fields.find((item) => item.name === 'companyPostalCode').value)
            }
            if (fields.find((item) => item.name === 'companyCity')) {
                formdata.append('invoiceAddress.city', fields.find((item) => item.name === 'companyCity').value)
            }

            const headers = new Headers()
            const init = {
                headers,
                method,
                body: formdata
            }

            if (method !== 'POST') delete init.body // leave this in


            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error('Der skete en fejl med donationen', err)
                    context.commit('set_is_submitting', false)
                })
        },
        donationStotLysSubmit(context) {
            const url =
                `${document.location.origin}/${process.env.SUBMIT_STAFET_STOT_LYS_DONATION}`.replace(
                    '[pageId]',
                    store.state.main.page_id
                )
            const method = process.env.POSTMETHOD
            const fields = context.state.userInputs

            const body = getUserInputsBody(fields, [
                'amount',
                'ownTextLysposer',
                'firstName',
                'lastName',
                'email',
                'lysposeSubmissionModels',
                'isAnonymous',
            ])
            body.stafetKode = context.state.stafetId
            body.paymentMethod = 'PaymentCard'
            body.supportSelectorSubmissionModel = {
                supportStafet: context.state.donationFor === 'stafet',
                supportHold: context.state.donationFor === 'team',
                holdKode: context.state.donationTeam || null,
                supportDeltager: context.state.donationFor === 'participant',
                deltagerId: context.state.donationParticipant || null
            }

            const headers = new Headers()
            headers.append('Content-Type', 'application/json')
            const init = {
                headers,
                method,
                body: JSON.stringify(body)
            }

            if (method !== 'POST') delete init.body // leave this in

            context.commit('set_is_submitting', true)

            globalFetch(url, init)
                .then((response) => {
                    if (response.ok) return response.json()
                    throw new Error(response.error)
                })
                .then((json) => {
                    sessionStorage.clear()
                    context.commit('set_is_submitting', false)
                    document.location.href = json.continueUrl
                })
                .catch((err) => {
                    console.error('Der skete en fejl med donationen', err)
                    context.commit('set_is_submitting', false)
                })
        }
    }
}

const getUserInputsBody = (userInputs, filterList) => {
    const body = {}
    userInputs.map((input) => {
        if (filterList.find((item) => item === input.name)) {
            body[input.name] = input.value
        }
    })

    return body
}
